import { faBuilding, faFileLines } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useMemo } from 'react';
import { SPONSOR_RELATION_ABSTRACT, SPONSOR_RELATION_ORGANIZATION } from '../../../../../data/constants/speakers';
import { speakerHasContent } from '../../../../../data/filters/speakers/speakerHasContent';
import { useSpeakerProgramItems } from '../../../../../data/hooks/schedule/useSpeakerProgramItems';
import UserAvatar from '../../../../elements/icons/UserAvatar';
import Link from '../../../../elements/Link';
import ListItem from '../../../../elements/ListItem/ListItem';
import { ListItemContent } from '../../../../elements/ListItem/ListItemContent';
import RightChevron from '../../../../elements/RightChevron/RightChevron';
import styles from './SpeakersList.module.scss';
import SpeakerLinkedSponsorIcon from './SpeakerLinkedSponsorIcon';
import altSpeakerAvatar from '../../../../../resources/icons/speaker_alt_avatar.png';

const SpeakerItem = (props) => {
    const { event, speaker } = props,
        programItems = useSpeakerProgramItems(event.id, speaker.id),
        contentLink = useMemo(() => {
            if (speaker.linked_sponsor_id) {
                return ['.', 'content', speaker.linked_sponsor_id].join('/');
            }
            return ['.', 'speakers', speaker.id].join('/');
        }, [speaker]),
        icon = useMemo(() => {
            if (speaker.linked_sponsor_id) {
                return <SpeakerLinkedSponsorIcon relation={speaker.linked_sponsor_relation} />;
            }
            return speaker.id && (speakerHasContent(speaker) || programItems.length) ? <RightChevron className={styles.icon} /> : null;
        }, [speaker]);

    return (
        <ListItem className={styles.SpeakerItem}>
            <Link href={['.', 'speakers', speaker.id].join('/')}>
                <UserAvatar className={styles.avatar} user={speaker} altSrc={altSpeakerAvatar} round />
            </Link>
            <ListItemContent href={contentLink}>
                {speaker.title ? <div className="text main">{speaker.title}</div> : null}
                <div className="text name">{speaker.name}</div>
                <div className="text position">{speaker.position}</div>
                <div className="text company">{speaker.company}</div>
                {speaker.role ? <div className="text small">{speaker.role}</div> : null}
                {speaker.speaker_extra ? <div className="text small">{speaker.speaker_extra}</div> : null}
            </ListItemContent>
            {icon ? <Link href={contentLink}>{icon}</Link> : null}
        </ListItem>
    );
};

export default SpeakerItem;
